<template>
  <transition name="expand">
    <div>
      <span>
        <mdl-textfield
          field-id="addProxyHolder"
          :label="labelText"
          :black-label="true"
          :placeholder="placeholderText"
          @inputting="typeHolder"
          :bvalue="proxyHolderName"
          @go-next-input="$emit('go-next')"
        ></mdl-textfield>
      </span>
      <div v-if="!hideChips">
        <span>
          Or choose from one of the following representatives who will be in
          attendance.
        </span>
        <div class="mdl-grid proxy-chip-grid">
          <div v-for="name in proxyHolders" :key="name">
            <div class="chip-container">
              <input
                type="radio"
                :id="name"
                class="gq-chip-radio"
                name="options"
                :value="name"
                v-model="proxyHolderName"
                @click="setProxyHolderChip(name)"
              />
              <label class="mdl-chip mdl-chip--contact" :for="name">
                <span class="mdl-chip__contact">
                  <i class="material-icons chip-icon">account_circle</i>
                </span>
                <span class="mdl-chip__text">{{ name }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import _ from 'lodash';
import mdlTextfield from '@/components/mdlTextfield.vue';

export default {
  components: {
    mdlTextfield
  },
  props: {
    proxyHolders: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selectedProxy: {
      type: String,
      default: ''
    },
    proxyDisplayOptions: {
      type: Object,
      required: true
    }
  },
  watch: {
    selectedProxy() {
      this.proxyHolderName = this.selectedProxy;
    }
  },
  computed: {
    hideChips() {
      return _.get(
        this.proxyDisplayOptions,
        'experimental_mode_hide_chips',
        false
      );
    },
    labelText() {
      const def = 'Your proxy holder';
      const label = _.get(this.proxyDisplayOptions, 'write_in_label', '');
      return label === '' ? def : label;
    },
    placeholderText() {
      const def = 'eg. John Smith';
      const placeholder = _.get(
        this.proxyDisplayOptions,
        'write_in_placeholder',
        ''
      );
      return placeholder === '' ? def : placeholder;
    }
  },
  data() {
    return {
      proxyHolderName: this.selectedProxy
    };
  },
  methods: {
    typeHolder(value) {
      this.proxyHolderName = value;
      this.$emit('inputting', value);
    },
    // Set into state the other proxy holder name
    setProxyHolderChip(value) {
      if (this.proxyHolderName == value) {
        this.$emit('inputting', '');
      } else {
        this.$emit('inputting', value);
      }
    }
  }
};
</script>

<style scoped>
.caption {
  font-size: 12px;
  line-height: 8px;
  color: rgb(63, 81, 181);
}

.label {
  color: rgb(63, 81, 181);
}

.gq-chip-cell {
  margin: 2px;
}

.chip-icon {
  margin-top: 4px;
}

.chip-container {
  padding-right: 5px;
}

input[type='radio'] {
  display: none;
}

input[type='radio']:checked + label {
  background-color: rgba(63, 81, 181, 0.92);
  color: #f7f7f7;
}
</style>
